const bugsnagKeys = {
  apiKey: '528dc6aae0ba2561f8a2873e2d0f703a',
};

export default bugsnagKeys;
